import React from 'react';
import './Footer.css';
import Arrow_Right from '../../data/img/Arrow - Right.png';
import emailIcon from '../../data/img/email.png';
const Footer = () => {
    return (
        <>
        <footer>
            <div className="container">
                <div>
                    <div>
                        <h4>WHO ARE WE</h4>
                        <p>BVarb.com is not less than a family, who is present in five continents globally and BVarb.com further wants to enhance the family by gathering in the team, people who are like minded and make them part of the team locally and we the BVarb.com company provides Arbitrage of E-entertainment platform with the help of Big Data algorithm tools.</p>
                        <button className='read-more-btn'>
                                Read <p>More<img src={Arrow_Right} alt=""/></p>
                        </button>
                    </div>
                    <div>
                        <h4>USEFUL LINKS</h4>
                        <ul>
                            <li>Crypto Way</li>
                            <li>Entertainment</li>
                            <li>FAQ</li>
                            <li>Term & Conditions</li>
                            <li>Privacy Policy</li>
                        </ul>
                    </div>
                    <div>
                        <h4>FOLLOW US</h4>
                        <p>The more specific it is, the stronger and clearer the scenario that the BVarb.com will be and the more often people will think about the BVarb.com contest.info@bvarb.com</p>
                    </div>
                    <div>
                        <h4>CONTACT US</h4>
                        <p>Your questions and comments are important to us. We've got everything covered for your needs</p>
                        
                        <div class="input-container">
                            <i class="fa fa-envelope icon">
                                <img src={emailIcon} alt="" />
                            </i>
                            <input class="input-field" type="email" placeholder="example@gmail.com" name="email"/>
                        </div>
                        <textarea
                        placeholder='Type your message here'
                         name="" id="" cols="30" rows="10"></textarea>
                         {/* <br /> */}
                         <button className='read-more-btn'>
                                Sub<p>mit<img src={Arrow_Right} alt=""/></p>
                        </button>
                    </div>
                </div>
            </div>
        </footer>
        </>
    );
};

export default Footer;